import React, { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import { useParams } from "react-router-dom";
import AuthServices from "../../services/AuthServices";
import "../../assets/css/certificate.css";
import {
  certiborder,
  certificateImg,
  backgroundcertificateImg,
} from "../imagepath";
import { format } from "date-fns";

const AutoCertificate = () => {
  const certificateRef = useRef(null);
  const { userid, type } = useParams();
  const [certificatesData, setCertificatesData] = useState(null);
  const [title, setCertificateTitle] = useState("Certificate");

  // Function to wait until all images load
  const waitForImagesToLoad = async () => {
    const images = certificateRef.current?.getElementsByTagName("img");
    if (!images) return;

    return Promise.all(
      [...images].map(
        (img) =>
          new Promise((resolve) => {
            if (img.complete) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = resolve;
            }
          })
      )
    );
  };

  // Function to generate and download PDF
  const generateAndDownloadPDF = async () => {
    try {
      if (!certificateRef.current) return;

      await waitForImagesToLoad();
      await new Promise((resolve) => setTimeout(resolve, 500));

      const canvas = await html2canvas(certificateRef.current, {
        scale: 2,
        useCORS: true,
      });
      const imgData = canvas.toDataURL("image/png", 0.7); // Reduce quality to avoid corrupt PNG errors

      // Create PDF exactly sized to canvas (1:1 match)
      const pdf = new jsPDF("landscape", "mm", "a4"); // Landscape mode

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      // Calculate new image dimensions to maintain aspect ratio
      const imgWidth = pdfWidth - 20; // Adjust for padding
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (imgHeight > pdfHeight) {
        // If the image is too tall, fit it within the PDF height
        const scaleFactor = pdfHeight / imgHeight;
        pdf.addImage(
          imgData,
          "PNG",
          10,
          10,
          imgWidth,
          pdfHeight - 20
        );
      } else {
        pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
      }
      pdf.save(`${title}.pdf`);
      window.close();
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  useEffect(() => {
    // Fetch certificate data from API
    const fetchCertificateData = async () => {
      try {
        const response = await AuthServices.viewCertificateByUserId({
          userid,
          type: atob(type),
        });
        console.log("Certificate Data:", response);

        setCertificateTitle(response.type || "Certificate");
        setCertificatesData(response.certificatedata);

        // Generate PDF after data loads
        setTimeout(() => {
          generateAndDownloadPDF();
        }, 2000);
      } catch (error) {
        console.error("Error fetching certificates:", error);
      }
    };

    fetchCertificateData();
  }, []);

  return (
    <div className="auto-certificate-container" style={{ height: "100vh" }}>
      {certificatesData && (
        <div
          className="certi-div"
          ref={certificateRef}
          style={{
            position: "relative",
            background: "none",
            padding: "0",
            maxWidth: "1320px",
            justifySelf: "center"

          }}
        >
          <img
            src={certiborder}
            alt="Border Frame"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              zIndex: 0,
            }}
          />
          <div
            style={{
              position: "relative",
              zIndex: 1,
              width: "90%",
              height: "1120px", // Fill all space so PDF includes it
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              color: "#000000",
              textAlign: "center",
              padding: "20px",
              boxSizing: "border-box",
              margin: "0 auto",
            }}
          >
            <img src={backgroundcertificateImg} className="certi-backimg" />
            <h1 className="certi-heading" style={{margin: "144px 0"}}>National Certification Program</h1>
            <p className="certi-sub-heading">{certificatesData.name}</p>
            <p style={{ fontSize: "24px" }}>{certificatesData.address}</p>
            <p
              style={{ fontSize: "18px", marginTop: "5px", fontWeight: "700" }}
            >
              Is Awarded & Certified on
            </p>
            <p className="certi-date">
              {format(
                new Date(certificatesData.completionDate),
                "MMMM do yyyy"
              )}
            </p>
            <p style={{ fontSize: "18px", fontWeight: "600" }}>By the</p>
            <p style={{ fontSize: "20px", fontWeight: "800", margin: "40px"}}>
              <span className="certi-pink">Angel</span>
              <span className="certi-blue">Watch</span> Foundation
            </p>
            <p style={{ fontSize: "16px", fontWeight: "500" }}>
              Expiration &nbsp;
              {format(
                new Date(certificatesData.expirationDate),
                "MMMM do yyyy"
              )}
            </p>

            <p className="align-img">
              <img
                src={certificateImg}
                className="certi-left-img"
                alt="Certificate Left"
              />
              <img
                src={certificateImg}
                className="certi-right-img"
                alt="Certificate Right"
              />
            </p>
            <p style={{ marginTop: "54px" }}>
              <h2
                style={{
                  fontSize: "12px",
                  marginBottom: "2px",
                  fontWeight: "500",
                }}
              >
                {certificatesData.stateid}
              </h2>
              <h2
                style={{
                  fontSize: "22px",
                  marginTop: "20px",
                  color: "red",
                  fontWeight: "700",
                  fontFamily: "Tahoma",
                }}
              >
                {title}
              </h2>
            </p>

            <p
              style={{ fontSize: "18px", marginTop: "15px", fontWeight: "600" , marginBottom: "60px" }}
            >
              The <span className="certi-pink">Angel</span>
              <span className="certi-blue">Watch</span> National Accreditation
              Program for the Safety & Security of Children
            </p>
            <p className="left-text">www.AngelWatch.org</p>
            <p className="right-text">Phone: 1-800-381-6794</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AutoCertificate;
